import React from 'react';
import { motion } from 'framer-motion';
import './RACHero.css';

const RACHero = ({ onTalkToTeam, onRequestCallback }) => {
  console.log('[RACHero] Component rendered');
  
  return (
    <section className="rac-hero">
      <div className="rac-hero-container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="rac-hero-content"
        >
          <h1 className="rac-hero-title">
            Own an Identified Dairy Animal. Hire it Back to PharmWealth for Managed Operations. Receive Monthly Hire Rent for Active Lease Days (per terms).
          </h1>
          <p className="rac-hero-subtitle">
            Purchase one or more mapped dairy animals and place them under PharmWealth's managed operations under an executed hire-back agreement. Hire rent is paid monthly and prorated by Active Lease Days. Monthly hire rent adjusts for planned dry periods (up to the 60-day Contract Year cap) and may pause during death, vet-certified unfit/non-performing, or replacement processing (including onboarding) as defined in the hire-back agreement.
          </p>
          
          <div className="rac-hero-badges">
            <div className="rac-badge">
              <span className="rac-badge-icon">✓</span>
              <span>1 Owner : 1 Animal Mapping</span>
            </div>
            <div className="rac-badge">
              <span className="rac-badge-icon">✓</span>
              <span>Monthly Hire Rent Payout (Prorated by Active Lease Days)</span>
            </div>
            <div className="rac-badge">
              <span className="rac-badge-icon">✓</span>
              <span>Insurance in Owner's Name (policy terms apply)</span>
            </div>
            <div className="rac-badge">
              <span className="rac-badge-icon">✓</span>
              <span>Daily Logs & Records</span>
            </div>
          </div>
          
          <div className="rac-hero-buttons">
            <button 
              onClick={onTalkToTeam}
              className="rac-btn rac-btn-primary"
            >
              Talk to RAC Team
            </button>
            <button 
              onClick={onRequestCallback}
              className="rac-btn rac-btn-secondary"
            >
              Request Call Back
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default RACHero;


